import SignInComponent from "../components/page/SignInComponent";

const SignInPage = () => {
  return <SignInComponent />;
};
export default SignInPage;
